import { Flex, Text } from '@chakra-ui/react'
import React, { useState } from 'react'
import { FaDownload, FaFile, FaFileCsv, FaFileImage, FaFileVideo, FaFolder } from 'react-icons/fa'
import { FileBox, GuideText, LabelFile } from '../../send/styles'
import { BsFillFileEarmarkPdfFill } from 'react-icons/bs'

interface IProps {
  id: string
  AtualizarArquivo: (e: React.ChangeEvent<HTMLInputElement>) => void
  tipo: number
  title: string
  isOpcional: boolean
}

export const BoxArquivo: React.FC<IProps> = ({ id, AtualizarArquivo, tipo, title, isOpcional }) => {
  const [TamanhoArquivo, setTamanhoArquivo] = useState('')
  const [NomeArquivo, setNomeArquivo] = useState('')

  const AttArquivo = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const arquivo = event.target.files?.[0]
    if (arquivo === null || arquivo === undefined) return

    if ((tipo === 1 && !arquivo?.name.toLowerCase().includes('.pdf')) || (tipo === 2 && !arquivo?.name.includes('.docx') && !arquivo?.name.toLowerCase().includes('.pdf'))) {
      event.target.value = ''
      AtualizarArquivo(event)
      return
    }

    const tamanhoEmKB = arquivo.size / 1024
    const tamanhoFormatado = tamanhoEmKB > 1024
      ? `${(tamanhoEmKB / 1024).toFixed(2)}MB`
      : `${tamanhoEmKB.toFixed(2)}KB`

    setTamanhoArquivo(tamanhoFormatado)
    setNomeArquivo(arquivo.name)

    AtualizarArquivo(event)
  }

  function GetTipoArquivo(): string {
    switch (tipo) {
      case 1:
        return 'PDF'
      case 2:
        return 'DOCX ou PDF'
      default:
        return ''
    }
  }

  function GetFileIcon(tipo: string): any {
    const tipoFormatado = tipo.toLowerCase()
    switch (tipoFormatado) {
      case 'csv':
        return <FaFileCsv/>
      case 'svg':
      case 'jpeg':
      case 'png':
      case 'jpg':
        return <FaFileImage/>
      case 'pdf':
        return <BsFillFileEarmarkPdfFill/>
      case 'mov':
      case 'mp4':
        return <FaFileVideo/>
      default:
        return <FaFile/>
    }
  }

  return (
    <FileBox isOpcional={isOpcional}>
      {
        NomeArquivo.length === 0
          ? <Flex flexDir={'column'} gap={'.75rem'} justifyContent={'center'} alignItems={'center'}>
            <Text fontSize={'1.125rem'} fontWeight={700} color={isOpcional ? 'var(--Orange)' : 'var(--Azul)'}>{title}</Text>
            <FaDownload color={isOpcional ? 'var(--Orange)' : 'var(--Azul)'} size={35} />
            <Flex flexDir={'column'} gap={'.25rem'}>
              <GuideText>Arraste e solte o arquivo no formato <strong>{GetTipoArquivo()}</strong> para fazer o envio</GuideText>
              <small>Tamanho limite: 25 MB</small>
            </Flex>
            <input id={id} type={'file'} onChange={AttArquivo} />
            <LabelFile theme={'27AE60'} htmlFor={id}><FaFolder />Selecionar arquivo</LabelFile>
          </Flex>
          : <>
            <Flex marginBottom={'1rem'} fontSize={'4rem'} flexDir={'column'}>
              <Text fontSize={'1.125rem'} fontWeight={700} color={'var(--Azul)'}>{title}</Text>
              <Text color={'var(--Azul)'}>
                {GetFileIcon(NomeArquivo.split('.')[NomeArquivo.split('.').length - 1])}
              </Text>
              <Flex flexDir={'column'} fontSize={'.875rem'}>
                <span>{NomeArquivo}</span>
                <small>Tamanho: <strong>{TamanhoArquivo}</strong></small>
              </Flex>
            </Flex>
            <div>
              <input id={id} type={'file'} onChange={AttArquivo} /><LabelFile theme={'27AE60'} htmlFor={id}><FaFolder />Selecionar arquivo</LabelFile>
            </div>
          </>
      }
    </FileBox>
  )
}
